import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.44531 6.75C2.44531 6.05964 3.00496 5.5 3.69531 5.5H20.1953C20.8857 5.5 21.4453 6.05964 21.4453 6.75C21.4453 7.44036 20.8857 8 20.1953 8H3.69531C3.00496 8 2.44531 7.44036 2.44531 6.75ZM2.44531 12C2.44531 11.3096 3.00496 10.75 3.69531 10.75H20.1953C20.8857 10.75 21.4453 11.3096 21.4453 12C21.4453 12.6904 20.8857 13.25 20.1953 13.25H3.69531C3.00496 13.25 2.44531 12.6904 2.44531 12ZM2.44531 17.25C2.44531 16.5596 3.00496 16 3.69531 16H20.1953C20.8857 16 21.4453 16.5596 21.4453 17.25C21.4453 17.9404 20.8857 18.5 20.1953 18.5H3.69531C3.00496 18.5 2.44531 17.9404 2.44531 17.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
